export default "__VITE_ASSET__BR05yVtK__"